<template lang="pug">
  section.login
    login-header(
      product-name="Ecosystems B2B"
      :multi-language="true"
      :client-logo="true"
    )
    main.login__main(:style='checkImage')
      router-view(:loading-text="password ? $t('password.sending') : $t('login.logging')" )
      div.align
        a(:href='checkHref' target='_blank')
          img.loginImg(:src= 'checkImgSrc')

    login-footer
</template>

<script>
import { mapGetters } from 'vuex'
import LoginHeader from '@/components/logingeneric/LoginHeader'
import LoginFooter from '@/components/logingeneric/B2bLoginFooter'
import LangSelector from '@/components/shared/LangSelector'

export default {
  name: 'the-b2b-login',

  computed: {
    loading () {
      return this.getLoaderState()
    },
    mobile () {
      return this.getIsMobile()
    },
    password () {
      const pwd = this.getIsPasswordForm()
      return pwd
    },
    checkImage () {
      console.log('>>>>> this.route.path ', this.$route.path)
      if (this.$route.path.includes('renfe')) {
        const bgImage = require('@/assets/images/login/renfeBack.jpg')
        return {
          backgroundImage: `url("${bgImage}")`,
          'background-repeat': 'no-repeat',
          'background-position-x': 'right',
          'background-size': '75%',
          'justify-content': 'left'
        }
      } else if (this.$route.path.includes('Canal')) {
        const bgImage = require('@/assets/images/login/canalBack.jpg')
        return {
          backgroundImage: `url("${bgImage}")`,
          'background-repeat': 'no-repeat',
          'background-position-x': 'right',
          'background-size': '75%',
          'justify-content': 'left'
        }
      } else if (this.$route.path.includes('accionaenergia')) {
        const bgImage = require('@/assets/images/login/accionaEnergiaBack.png')
        return {
          backgroundImage: `url("${bgImage}")`,
          'background-repeat': 'no-repeat',
          'background-position-x': 'right',
          'background-size': '75%',
          'justify-content': 'left'
        }
      } else if (this.$route.path.includes('ree')) {
        const bgImage = require('@/assets/images/login/reeBack.jpg')
        return {
          backgroundImage: `url("${bgImage}")`,
          'background-repeat': 'no-repeat',
          'background-position-x': 'left',
          'background-size': '85%',
          'justify-content': 'right'
        }
      } else if (this.$route.path.includes('vocento')) {
        const bgImage = require('@/assets/images/login/vocentoBack.jpg')
        return {
          backgroundImage: `url("${bgImage}")`,
          'background-repeat': 'no-repeat',
          'background-position-x': 'right',
          'background-size': '100%',
          'justify-content': 'center',
          'padding-right': '25%'
        }
      } else if (this.$route.path.includes('correos')) {
        return ''
      }
      return {
        'justify-content': 'center'
      }
    },
    checkHref () {
      if (this.$route.path.includes('correos')) {
        return 'https://www.correosexpress.com/'
      }
      return '#'
    },
    checkImgSrc () {
      if (this.$route.path.includes('correos')) {
        return require('@/assets/images/login/correosBack.png')
      }
      return ''
    }
  },

  components: {
    LoginHeader,
    LoginFooter,
    LangSelector
  },

  methods: {
    ...mapGetters([
      'getLoaderState',
      'getIsMobile',
      'getIsPasswordForm'
    ]),
    getBackgrowndImgUrl () {
      const bgImage = require('@/assets/images/login/renfeBack.jpg')
      return {
        backgroundImage: `url("${bgImage}")`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .login {
  height: 100vh;
  display: flex;
  flex-direction: column;

  color: var(--arycolor-txt-prim);
  background-color: var(--color-bg-primary);

  &__main {
    padding: $space-300;
    display: flex;
    width: 100%;
    flex: 1;
  }
  img.loginImg {
    width: 110%;
  }
  .align {
    padding: 0px 0px 0px 62px;
    margin: -20px -100px 0px 0px;
  }
}
</style>
